import cx from "classnames";
import ENV from "config";
import kebabCase from "lodash/kebabCase";
import IconFavIcon from "../IconFavIcon/IconFavIcon";
import IconAmericanFootball from "./components/IconAmericanFootball/IconAmericanFootball";
import IconAustralianRules from "./components/IconAustralianRules/IconAustralianRules";
import IconAutoRacing from "./components/IconAutoRacing/IconAutoRacing";
import IconBaseball from "./components/IconBaseball/IconBaseball";
import IconBasketball from "./components/IconBasketball/IconBasketball";
import IconBicycle from "./components/IconBicycle/IconBicycle";
import IconBoxing from "./components/IconBoxing/IconBoxing";
import IconCricket from "./components/IconCricket/IconCricket";
import IconEsports from "./components/IconEsports/IconEsports";
import IconGalaxyBet from "./components/IconGalaxyBet/IconGalaxyBet";
import IconGolf from "./components/IconGolf/IconGolf";
import IconHorseRacing from "./components/IconHorseRacing/IconHorseRacing";
import IconIceHockey from "./components/IconIceHockey/IconIceHockey";
import IconMotorbike from "./components/IconMotorbike/IconMotorbike";
import IconNCAABasketball from "./components/IconNCAABasketball/IconNCAABasketball";
import IconNCAAFootball from "./components/IconNCAAFootball/IconNCAAFootball";
import IconOlympics from "./components/IconOlympics/IconOlympics";
import IconPoker from "./components/IconPoker/IconPoker";
import IconRugby from "./components/IconRugby/IconRugby";
import IconRugbyLeague from "./components/IconRugbyLeague/IconRugbyLeague";
import IconSoccer from "./components/IconSoccer/IconSoccer";
import IconSwimming from "./components/IconSwimming/IconSwimming";
import IconTennis from "./components/IconTennis/IconTennis";
import "./IconSports.scss";
type Props = {
  name: string;
  className?: string;
  isActive?: boolean;
};

const IconSports = (props: Props): any => {
  let { name, className, isActive } = props;
  const newProps = {
    className: cx("icon-sports", className),
    isActive,
  };
  // use kebabCase to lowercase, trim and replace whitespace between words with dash
  const sportsName = kebabCase(name);

  switch (sportsName) {
    case "all-sports":
      return ENV.CSS_THEME === "GALAXYBET" ? (
        <IconGalaxyBet {...newProps} />
      ) : (
        <IconFavIcon {...newProps} />
      );

    case "american-football":
      return <IconAmericanFootball {...newProps} />;

    case "美式足球":
      return <IconAmericanFootball {...newProps} />;

    case "australian-rules":
      return <IconAustralianRules {...newProps} />;

    case "auto-racing":
      return <IconAutoRacing {...newProps} />;

    case "baseball":
      return <IconBaseball {...newProps} />;

    case "棒球":
      return <IconBaseball {...newProps} />;

    case "basketball":
      return <IconBasketball {...newProps} />;

    case "篮球":
      return <IconBasketball {...newProps} />;

    case "bicycle":
      return <IconBicycle {...newProps} />;

    case "boxing":
      return <IconBoxing {...newProps} />;

    case "mma":
      return <IconBoxing {...newProps} />;

    case "cricket":
      return <IconCricket {...newProps} />;

    case "esports":
      return <IconEsports {...newProps} />;

    case "golf":
      return <IconGolf {...newProps} />;

    case "horse-racing":
      return <IconHorseRacing {...newProps} />;

    case "ice-hockey":
      return <IconIceHockey {...newProps} />;

    case "冰球":
      return <IconIceHockey {...newProps} />;

    case "moterbike":
      return <IconMotorbike {...newProps} />;

    case "ncaa-basketball":
      return <IconNCAABasketball {...newProps} />;

    case "ncaa-football":
      return <IconNCAAFootball {...newProps} />;

    case "olympics":
      return <IconOlympics {...newProps} />;

    case "poker":
      return <IconPoker {...newProps} />;

    case "rugby":
      return <IconRugby {...newProps} />;

    case "rugby-league":
      return <IconRugbyLeague {...newProps} />;

    case "soccer":
      return <IconSoccer {...newProps} />;

    case "足球":
      return <IconSoccer {...newProps} />;

    case "swimming":
      return <IconSwimming {...newProps} />;

    case "tennis":
      return <IconTennis {...newProps} />;

    default:
      if (sportsName) {
        console.error("No sports icon for: ", sportsName);
      }
      return null;
  }
};

export default IconSports;
